import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import * as React from "react";
import Layout from "./layout/default";
import Login from "./routes/Login/Login.js";
import Dashboard from "./routes/Dashboard/Dashboard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./assets/styles/main.scss";

const Offers = React.lazy(() => import("./routes/Offers/Offers.js"));
const ModifyOffer = React.lazy(() =>
  import("./routes/ModifyOffer/ModifyOffer")
);
const ViewOffer = React.lazy(() => import("./routes/ViewOffer/ViewOffer"));
const Contracts = React.lazy(() =>
  import("./routes/Contracts/Contracts/contracts")
);
const ContractsAccepted = React.lazy(() =>
  import("./routes/Contracts/ContractsAccepted/contractsAccepted")
);
const AddStarter = React.lazy(() =>
  import("./routes/AddContracts/AddStarter/AddStarter")
);
const Operators = React.lazy(() => import("./routes/Operators/Operators"));
const ModifyOperator = React.lazy(() =>
  import("./routes/ModifyOperator/ModifyOperator")
);
const ViewOperator = React.lazy(() =>
  import("./routes/ViewOperator/ViewOperator")
);
const Contractors = React.lazy(() =>
  import("./routes/Contractors/Contractors")
);
const ViewContractor = React.lazy(() =>
  import("./routes/ViewContractor/ViewContractor")
);
const ViewContract = React.lazy(() =>
  import("./routes/ViewContract/ViewContract")
);
const Reports = React.lazy(() => import("./routes/Reports/Reports"));
const AddReport = React.lazy(() => import("./routes/AddReport/AddReport"));
const ViewReport = React.lazy(() => import("./routes/ViewReport/ViewReport"));
const Products = React.lazy(() => import("./routes/Products/Products"));
const Error404 = React.lazy(() => import("./routes/Error404/Error404"));
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#212a72",
      // dark: will be calculated from palette.primary.main,
      contrastText: "#fff",
    },
    secondary: {
      main: "#D10000",
      // dark: will be calculated from palette.primary.main,
      contrastText: "#fff",
    },
    // Provide every color token (light, main, dark, and contrastText) when using
    // custom colors for props in Material UI's components.
    // Then you will be able to use it like this: `<Button color="custom">`
    // (For TypeScript, you need to add module augmentation for the `custom` value)
    custom: {
      light: "#ffa726",
      main: "#f57c00",
      dark: "#ef6c00",
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route
              path="/offers"
              element={
                <React.Suspense fallback={<></>}>
                  <Offers />
                </React.Suspense>
              }
            />
            <Route
              path="/products"
              element={
                <React.Suspense fallback={<></>}>
                  <Products />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/view/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/dashboard"
              element={
                <React.Suspense fallback={<></>}>
                  <Contracts />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/list"
              element={
                <React.Suspense fallback={<></>}>
                  <ContractsAccepted />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/add/starter"
              element={
                <React.Suspense fallback={<></>}>
                  <AddStarter />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/add/"
              element={
                <React.Suspense fallback={<></>}>
                  <AddStarter />
                </React.Suspense>
              }
            />
            <Route
              path="/contracts/edit/2/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />

            <Route
              path="/contracts/edit/3/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />

            <Route
              path="/contracts/edit/5/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />

            <Route
              path="/contracts/edit/6/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />

            <Route
              path="/contracts/edit/13/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContract />
                </React.Suspense>
              }
            />

            <Route
              path="/operators"
              element={
                <React.Suspense fallback={<></>}>
                  <Operators />
                </React.Suspense>
              }
            />
            <Route
              path="/operators/add"
              element={
                <React.Suspense fallback={<></>}>
                  <ModifyOperator />
                </React.Suspense>
              }
            />
            <Route
              path="/operators/edit/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ModifyOperator />
                </React.Suspense>
              }
            />
            <Route
              path="/operators/view/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewOperator />
                </React.Suspense>
              }
            />

            <Route
              path="/contractors"
              element={
                <React.Suspense fallback={<></>}>
                  <Contractors />
                </React.Suspense>
              }
            />
            <Route
              path="/contractors/view/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewContractor />
                </React.Suspense>
              }
            />

            <Route
              path="/reports"
              element={
                <React.Suspense fallback={<></>}>
                  <Reports />
                </React.Suspense>
              }
            />
            <Route
              path="/reports/add"
              element={
                <React.Suspense fallback={<></>}>
                  <AddReport />
                </React.Suspense>
              }
            />
            <Route
              path="/reports/view/:reportId"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewReport />
                </React.Suspense>
              }
            />

            <Route
              path="/offers/add"
              element={
                <React.Suspense fallback={<></>}>
                  <ModifyOffer />
                </React.Suspense>
              }
            />
            <Route
              path="/offers/edit/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ModifyOffer />
                </React.Suspense>
              }
            />
            <Route
              path="/offers/view/:id"
              element={
                <React.Suspense fallback={<></>}>
                  <ViewOffer />
                </React.Suspense>
              }
            />
          </Route>
          {/* </Route> */}

          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
